import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rate-product',
  templateUrl: './rate-product.component.html',
  styleUrls: ['./rate-product.component.scss']
})
export class RateProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
